import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchCurrencyById,
  fetchCurrencies,
  updateCurrency,
  updateStatusInCurrency,
} from "./thunk";

interface CurrencyState {
  currencyList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCurrency: any;
}

const initialState: CurrencyState = {
  currencyList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCurrency: null,
};

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrencies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrencies.fulfilled, (state, action) => {
        state.loading = false;
        state.currencyList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchCurrencies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      })
      .addCase(fetchCurrencyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrencyById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCurrency = action.payload;
      })
      .addCase(fetchCurrencyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateCurrency.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.currencyList = state.currencyList.map((dist) =>
          dist.id === action.payload.id ? action.payload : dist
        );
      })
      .addCase(updateCurrency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update packages";
      })
      .addCase(updateStatusInCurrency.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.currencyList = state.currencyList.map((dist) =>
        //   dist.id === action.payload.id ? action.payload : dist
        // );
      })

      .addCase(updateStatusInCurrency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      });
  },
});

export default currencySlice.reducer;
